// extracted by mini-css-extract-plugin
module.exports = {"btsolid":"userDetail_btsolid_2MmgD"};